// Case.dataBasis mirrors the backend enum: PRIMARY (all first-hand), SECONDARY (all published
// reporting), MIXED (both). Cases read before the migration may carry only the old isPrimaryData
// boolean, which the backend keeps as a derived mirror; basisFromCase() handles both.
export type DataBasis = 'PRIMARY' | 'SECONDARY' | 'MIXED';

export const DATA_BASIS_VALUES: DataBasis[] = ['PRIMARY', 'SECONDARY', 'MIXED'];

export const DATA_BASIS_LABEL: Record<DataBasis, string> = {
  PRIMARY: 'Primary Data',
  SECONDARY: 'Secondary Data',
  MIXED: 'Mixed Data',
};

export const DATA_BASIS_TITLE: Record<DataBasis, string> = {
  PRIMARY: 'Primary data: documented first-hand with the people affected',
  SECONDARY: 'Secondary data: from published reporting',
  MIXED: 'Mixed: documented first-hand and corroborated by published reporting',
};

export const DATA_BASIS_LETTER: Record<DataBasis, string> = { PRIMARY: 'P', SECONDARY: 'S', MIXED: 'M' };

export const basisFromCase = (c: { dataBasis?: string | null; isPrimaryData?: boolean | null } | null | undefined): DataBasis | undefined => {
  if (!c) return undefined;
  if (c.dataBasis && (DATA_BASIS_VALUES as string[]).includes(c.dataBasis)) return c.dataBasis as DataBasis;
  if (c.isPrimaryData === true) return 'PRIMARY';
  if (c.isPrimaryData === false) return 'SECONDARY';
  return undefined;
};

/** The AI pipeline only ever touches cases with no first-hand material. */
export const isSecondaryOnly = (c: { dataBasis?: string | null; isPrimaryData?: boolean | null } | null | undefined): boolean => basisFromCase(c) === 'SECONDARY';

/** PRIMARY or MIXED: the case holds first-hand material, so it is protected from merges and machine updates. */
export const hasFirstHand = (c: { dataBasis?: string | null; isPrimaryData?: boolean | null } | null | undefined): boolean => {
  const b = basisFromCase(c);
  return b === 'PRIMARY' || b === 'MIXED';
};
